module.exports = __webpack_public_path__ + "static/img/message.055d42a4.png";